__webpack_require__.p = "/Hospital-dashboard/";